// 外卖宝
function getUAmsg() {
  const ua = window.navigator.userAgent;
  if (!ua.includes('giao#')) return {};
  const objString = ua.split('giao#')[1];

  const paramsArray = objString.split(' ');
  const obj = {};
  paramsArray.forEach(item => {
    obj[item.split('/')[0]] = item.split('/')[1];
  });
  return obj;
}
const uaMsg = getUAmsg();

export const isRebateApp = uaMsg.AppName === 'takeout';

// 骑士卡
function funIsIOS(ua) {
  if (/\bcpu(?: iphone)? os /.test(ua)) {
    return /\bcpu(?: iphone)? os ([0-9._]+)/.test(ua);
  }
  if (ua.indexOf('iph os ') !== -1) {
    return /\biph os ([0-9_]+)/.test(ua);
  }
  return /\bios\b/.test(ua);
}

function funIsAndroid(ua) {
  if (ua.indexOf('android') >= 0) {
    // eslint-disable-next-line no-useless-escape
    return /\bandroid[ \/-]?([0-9.x]+)?/.test(ua);
  }
  if (ua.indexOf('adr') >= 0) {
    if (ua.indexOf('mqqbrowser') >= 0) {
      return /\badr[ ]\(linux; u; ([0-9.]+)?/.test(ua);
    }
    return /\badr(?:[ ]([0-9.]+))?/.test(ua);
  }
  return /android/.test(ua);
}


// 导出
export const ua = window.navigator.userAgent.toLowerCase();
export const isWX = /micromessenger/.test(ua);
export const isQQ = /qq/.test(ua);
export const isBlackAPP = /ZZC(Android|IOS)\/black\//.test(navigator.userAgent);
export const isTiShen = /taisem|(ZZCIOS\/black\/1\.20)/.test(ua);
export const isIOS = funIsIOS(ua);
export const isAndroid = funIsAndroid(ua);
export const appVersion = window.navigator.userAgent.split('/')[2] || '1.12.0';
export const isTaiSem = /taisem/.test(ua); // 粤语
export const isBanana = { isTS: isIOS && /IsBanana\/1/i.test(ua) }; // 是否提审版本 ios默认是
export const isSafari = /version\/([\d.]+).*safari/.test(ua);

// eslint-disable-next-line no-underscore-dangle
export const isMiniWebview = window.__wxjs_environment === 'miniprogram'; // 小程序webview
export const isAPP = isBlackAPP || isRebateApp;
export const isBoxAPP = uaMsg.AppName === 'bbox';
export const boxAPPChannel = uaMsg.Channel;
export const isZfbAPP = /alipayclient/.test(window.navigator.userAgent.toLowerCase());
export const isZfbMiniProgram = /alipayclient/.test(window.navigator.userAgent.toLowerCase()) && /miniprogram/.test(window.navigator.userAgent.toLowerCase());
